<!-- make item border gray  -->
<div>
  <form
    (ngSubmit)="submit()"
    (keydown.enter)="handleEnter($event)"
    [formGroup]="formGroup"
    novalidate="novalidate"
    class="dynamic-form-container"
    [id]="formConfigs.id"
  >
    <mat-card-content class="row d-flex" [ngClass]="formConfigs.styles?.bodyClass">
      @for (item of formConfigs.items; track item.key) {
        @if (!item.hidden?.()) {
          <div [ngClass]="getItemClass(item)">
            @switch (item.controlType) {
              @case (controlType.INPUT) {
                <div class="row">
                  @if (item.label && item.labelDirection !== 'inside') {
                    <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-2' : 'col-sm-12'">
                      <mat-label
                        class="mat-subtitle-2 text-[13px] font-medium flex gap-1 items-center relative w-full min-w-0"
                        [ngClass]="{ required: hasRequired(item), 'm-b-8': item.labelDirection !== 'horizontal' }"
                      >
                        <span class="truncate min-w-0 flex-1" [title]="item.label | translate">{{ item.label | translate }}</span>
                        @if (item.labelIcon) {
                          <mat-icon class="label-icon shrink-0" [style.color]="'#0000008a'" [ngClass]="item.labelIcon.class ?? '!w-5 !h-5 !text-[1.26rem]'" [matTooltip]="(item.labelIcon.tooltip ?? '') | translate" >{{item.labelIcon.iconName}}</mat-icon>
                        }
                      </mat-label>
                    </div>
                  }
                  <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-10' : 'col-sm-12'">
                    <mat-form-field [ngClass]="item.inputConfig?.class" [appearance]="item.appearance ?? 'fill'" class="w-100 tight-input" subscriptSizing="dynamic">
                      @if (item.labelDirection === 'inside') {
                        <mat-label>{{ item.label ?? '' | translate }}</mat-label>
                      }
                      @if (item.inputConfig?.isNumber) {
                        <input
                          #dynamicElements
                          matInput
                          class="autofill-transparent"
                          [formControlName]="item.key"
                          [placeholder]="item.inputConfig?.placeholder ?? ''"
                          [readonly]="item.inputConfig?.readonly"
                          [type]="item.inputConfig?.type ?? (item.inputConfig?.isPassword && !item.inputConfig?.showingPassword ? 'password' : 'text')"
                          appNumberOnly
                        />
                      } @else {
                        <!-- autocomplete="new-password" to prevent autocomplete -->
                        <input
                          #dynamicElements
                          matInput
                          class="autofill-transparent"
                          [formControlName]="item.key"
                          [id]="item.key"
                          [placeholder]="item.inputConfig?.placeholder ?? ''"
                          [readonly]="item.inputConfig?.readonly"
                          autocomplete="new-password"
                          emptyToNull
                          [type]="item.inputConfig?.type ?? (item.inputConfig?.isPassword && !item.inputConfig?.showingPassword ? 'password' : 'text')"
                        />
                      }
                      @if (item.inputConfig?.isPassword) {
                        <button class="password-icon" mat-icon-button matSuffix (click)="toggleShowPassword($event, item)">
                          <mat-icon class="d-flex justify-content-center align-items-center f-s-18">
                            {{ item.inputConfig?.showingPassword ? 'visibility_off' : 'visibility' }}
                          </mat-icon>
                        </button>
                      }
                      @if (item.hint) {
                        <mat-hint>{{ item.hint | translate }}</mat-hint>
                      }
                    </mat-form-field>
                    <ng-container *ngTemplateOutlet="errorTemplate; context: { $implicit: item }" />
                  </div>
                </div>
              }
              @case (controlType.SELECT) {
                <div class="row">
                  @if (item.label) {
                    <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-2' : 'col-sm-12'">
                      <mat-label
                        class="mat-subtitle-2 text-[13px] font-medium flex gap-1 items-center relative w-full min-w-0"
                        [ngClass]="{ required: hasRequired(item), 'm-b-8': item.labelDirection !== 'horizontal' }"
                      >
                        <span class="truncate min-w-0 flex-1" [title]="item.label | translate">{{ item.label | translate }}</span>
                        @if (item.labelIcon) {
                          <mat-icon class="label-icon shrink-0" [style.color]="'#0000008a'" [ngClass]="item.labelIcon.class ?? '!w-5 !h-5 !text-[1.26rem]'" [matTooltip]="(item.labelIcon.tooltip ?? '') | translate" >{{item.labelIcon.iconName}}</mat-icon>
                        }
                      </mat-label>
                    </div>
                  }
                  <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-10' : 'col-sm-12'">
                    <app-form-select
                      #dynamicElements
                      [appearance]="item.appearance"
                      [placeholder]="item.selectionConfig?.placeholder ?? ''"
                      [formControlName]="item.key"
                      [fetchData]="item.fetchDataAPI"
                      [mapApiResponse]="item.mapApiResponse"
                      [dataSource]="item?.dataSource ?? []"
                      [selectionConfig]="item?.selectionConfig ?? {}"
                      [readonly]="item.inputConfig?.readonly ?? false"
                    ></app-form-select>
                    <ng-container *ngTemplateOutlet="errorTemplate; context: { $implicit: item }" />
                  </div>
                </div>
              }
              @case (controlType.AUTOCOMPLETE) {
                <div class="row">
                  @if (item.label) {
                    <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-2' : 'col-sm-12'">
                      <mat-label
                        class="mat-subtitle-2 text-[13px] font-medium flex gap-1 items-center relative w-full min-w-0 m-b-8"
                        [ngClass]="{ required: hasRequired(item), 'm-b-8': item.labelDirection !== 'horizontal' }"
                      >
                        <span class="truncate min-w-0 flex-1" [title]="item.label | translate">{{ item.label | translate }}</span>
                        @if (item.labelIcon) {
                          <mat-icon class="label-icon shrink-0" [style.color]="'#0000008a'" [ngClass]="item.labelIcon.class ?? '!w-5 !h-5 !text-[1.26rem]'" [matTooltip]="(item.labelIcon.tooltip ?? '') | translate" >{{item.labelIcon.iconName}}</mat-icon>
                        }
                      </mat-label>
                    </div>
                  }
                  <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-10' : 'col-sm-12'">
                    <app-autocomplete
                      #dynamicElements
                      [appearance]="item.appearance"
                      [placeholder]="item.selectionConfig?.placeholder ?? ''"
                      [formControlName]="item.key"
                      [dataSource]="item?.dataSource ?? []"
                      [fetchData]="item.fetchDataAPI"
                      [mapApiResponse]="item.mapApiResponse"
                      [selectionConfig]="item?.selectionConfig ?? {}"
                    ></app-autocomplete>
                    <ng-container *ngTemplateOutlet="errorTemplate; context: { $implicit: item }" />
                  </div>
                </div>
              }
              @case (controlType.TEXTAREA) {
                <div class="row">
                  @if (item.label) {
                    <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-2' : 'col-sm-12'">
                      <mat-label
                        class="mat-subtitle-2 font-medium text-[13px] flex gap-1 items-center relative w-full min-w-0"
                        [ngClass]="{ required: hasRequired(item), 'm-b-8': item.labelDirection !== 'horizontal' }"
                      >
                        <span class="truncate min-w-0 flex-1" [title]="item.label | translate">{{ item.label | translate }}</span>
                        @if (item.labelIcon) {
                          <mat-icon class="label-icon shrink-0" [style.color]="'#0000008a'" [ngClass]="item.labelIcon.class ?? '!w-5 !h-5 !text-[1.26rem]'" [matTooltip]="(item.labelIcon.tooltip ?? '') | translate" >{{item.labelIcon.iconName}}</mat-icon>
                        }
                      </mat-label>
                    </div>
                  }
                  <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-10' : 'col-sm-12'">
                    <mat-form-field [appearance]="item.appearance ?? 'fill'" class="w-100 tight-input" subscriptSizing="dynamic">
                      <textarea
                        #dynamicElements
                        [rows]="item.inputConfig?.textareaRows"
                        [formControlName]="item.key"
                        [id]="item.key"
                        matInput
                        emptyToNull
                        [readonly]="item.inputConfig?.readonly"
                      ></textarea>
                      @if (item.hint) {
                        <mat-hint>{{ item.hint | translate }}</mat-hint>
                      }
                    </mat-form-field>
                    <ng-container *ngTemplateOutlet="errorTemplate; context: { $implicit: item }" />
                  </div>
                </div>
              }
              @case (controlType.CHECKBOX) {
                <mat-checkbox #dynamicElements color="primary" class="dynamic-form-checkbox" [formControlName]="item.key">
                  {{ item.label ?? '' | translate }}
                </mat-checkbox>
              }
              @case (controlType.DATEPICKER) {
                <div class="row">
                  @if (item.label) {
                    <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-2' : 'col-sm-12'">
                      <mat-label
                        class="mat-subtitle-2 f-w-600 flex gap-1 items-center relative w-full min-w-0"
                        [ngClass]="{ required: hasRequired(item), 'm-b-8': item.labelDirection !== 'horizontal' }"
                      >
                        <span class="truncate min-w-0 flex-1" [title]="item.label | translate">{{ item.label | translate }}</span>
                        @if (item.labelIcon) {
                          <mat-icon class="label-icon shrink-0" [style.color]="'#0000008a'" [ngClass]="item.labelIcon.class ?? '!w-5 !h-5 !text-[1.26rem]'" [matTooltip]="(item.labelIcon.tooltip ?? '') | translate" >{{item.labelIcon.iconName}}</mat-icon>
                        }
                      </mat-label>
                    </div>
                  }
                  <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-10' : 'col-sm-12'">
                    <app-form-date-picker #dynamicElements [formControlName]="item.key" [datePickerConfig]="item?.datePickerConfig ?? {}" />
                    <ng-container *ngTemplateOutlet="errorTemplate; context: { $implicit: item }" />
                  </div>
                </div>
              }
              @case (controlType.RADIO) {
                <div class="row">
                  @if (item.label) {
                    <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-2' : 'col-sm-12'">
                      <mat-label
                        class="mat-subtitle-2 f-w-600 flex gap-1 items-center relative w-full min-w-0"
                        [ngClass]="{ required: hasRequired(item), 'm-b-8': item.labelDirection !== 'horizontal' }"
                      >
                        <span class="truncate min-w-0 flex-1" [title]="item.label | translate">{{ item.label | translate }}</span>
                        @if (item.labelIcon) {
                          <mat-icon class="label-icon shrink-0" [style.color]="'#0000008a'" [ngClass]="item.labelIcon.class ?? '!w-5 !h-5 !text-[1.26rem]'" [matTooltip]="(item.labelIcon.tooltip ?? '') | translate" >{{item.labelIcon.iconName}}</mat-icon>
                        }
                      </mat-label>
                    </div>
                  }
                  <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-10 d-flex align-items-center m-b-6' : 'col-sm-12'">
                    <mat-radio-group #dynamicElements [formControlName]="item.key" [ngStyle]="item.radioGroupStyle">
                      <mat-radio-button *ngFor="let option of item.dataSource" [value]="option.value" color="primary">
                        {{ option.text | translate }}
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              }
              @case (controlType.FILE) {
                <div class="row w-100 m-x-0">
                  @if (item.label) {
                    <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-2' : 'col-sm-12'">
                      <mat-label
                        class="mat-subtitle-2 f-w-600 flex gap-1 items-center relative w-full min-w-0"
                        [ngClass]="{ required: hasRequired(item), 'm-b-8': item.labelDirection !== 'horizontal' }"
                      >
                        <span class="truncate min-w-0 flex-1" [title]="item.label | translate">{{ item.label | translate }}</span>
                        @if (item.labelIcon) {
                          <mat-icon class="label-icon shrink-0" [style.color]="'#0000008a'" [ngClass]="item.labelIcon.class ?? '!w-5 !h-5 !text-[1.26rem]'" [matTooltip]="(item.labelIcon.tooltip ?? '') | translate" >{{item.labelIcon.iconName}}</mat-icon>
                        }
                      </mat-label>
                    </div>
                  }
                  <div [ngClass]="item.labelDirection === 'horizontal' ? 'col-sm-10 d-flex align-items-center m-b-6' : 'col-sm-12'">
                    <app-select-file
                      #dynamicElements
                      [formGroup]="formGroup"
                      [fileSelectConfig]="item?.fileSelectConfig ?? {}"
                      [controlName]="item.key"
                    />
                  </div>
                </div>
              }
              @case (controlType.DATE_RANGE_PICKER) {
                <app-form-date-range-picker
                  #dynamicElements
                  [formControlName]="item.key"
                  [dateRangePickerConfig]="item?.dateRangePickerConfig ?? {}"
                />
              }
              @case (controlType.DYNAMIC_COMPONENT) {
                <ng-template *ngComponentOutlet="item.dynamicComponentConfig?.component; inputs: item.dynamicComponentConfig?.inputs" />
              }
              @case (controlType.SWITCH) {
                <mat-slide-toggle #dynamicElements color="primary" [formControlName]="item.key">
                  {{ item.label ?? '' | translate }}
                </mat-slide-toggle>
              }
            }
          </div>
        }
      }
    </mat-card-content>
    @if (formConfigs.actions) {
      <mat-card-actions [ngClass]="formConfigs.styles?.footerClass">
        @if (formConfigs.styles?.footerNotice; as notice) {
          @if (!notice.hidden?.()) {
            <span class="mr-auto inline-flex items-center gap-3 text-sm font-medium text-[#a15c00] dark:text-amber-300">
              <span class="size-2 shrink-0 rounded-full bg-[#d48600] dark:bg-amber-400"></span>
              {{ notice.text | translate }}
            </span>
          }
        }
        @for (btnConfig of formConfigs.actions; track $index) {
          @if (!btnConfig.hidden?.()) {
            <app-form-button [spinLoader]="spinLoader" [btnConfig]="btnConfig" [ngClass]="btnConfig.layoutClass" />
          }
        }
      </mat-card-actions>
    }
  </form>
</div>

<ng-template #errorTemplate let-item>
  @if (!item.alwaysHideErrorMsg) {
    <mat-error>
      @for (error of getErrorMessage(item); track $index) {
        <span>
          <mat-icon class="error-icon">error_outline</mat-icon>
          {{ error }}
          <br />
        </span>
      }
    </mat-error>
  }
</ng-template>
